module.exports = __webpack_public_path__ + "assets/certificate_pdf/DUKE_ML.9bccf171.pdf";